import {
  AppBar,
  Toolbar,
  IconButton,
  Icon,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Button,
} from "@material-ui/core";
import { Translator } from "@itarget/shared";
import Profile from "./Profile";

const MobileHeader = ({
  logo,
  client,
  user,
  shoppingCarts,
  classes,
  handleDrawerToggle,
  mobileOpen,
  menuData,
  parseTitle,
}) => (
  <AppBar className={classes.header}>
    <Toolbar className={classes.mainMenuMobile}>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={handleDrawerToggle}
      >
        <Icon>menu</Icon>
      </IconButton>
      {logo && (
        <a href="/" className={classes.logo}>
          <img alt={`Logo da ${client}`} src={logo} />
        </a>
      )}
      <Box className={classes.authenticateContainer}>
        {user?.data ? (
          <Profile
            user={user}
            classes={classes}
            shoppingCarts={shoppingCarts}
          />
        ) : (
          <Button
            href="/login"
            variant="contained"
            className={classes.loginButton}
          >
            <Translator transRef="translation.Login" />
          </Button>
        )}
      </Box>
    </Toolbar>
    <Drawer anchor="left" open={mobileOpen} onClose={handleDrawerToggle}>
      <List className={classes.drawerList}>
        {menuData?.menu_mobile &&
          menuData.menu_mobile.map((item, index) => (
            <ListItem
              key={item.url || index}
              role="menuitem"
              aria-label={item.title}
              component="a"
              href={item.url}
            >
              <ListItemText primary={parseTitle(item.title)} />
            </ListItem>
          ))}
      </List>
    </Drawer>
  </AppBar>
);

export default MobileHeader;
